import { render, staticRenderFns } from "./BizEnterprisePensionList.vue?vue&type=template&id=35a085a3&"
import script from "./BizEnterprisePensionList.vue?vue&type=script&lang=js&"
export * from "./BizEnterprisePensionList.vue?vue&type=script&lang=js&"
import style0 from "./BizEnterprisePensionList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports